export default {"src":"/_next/static/media/Janboo.4ec9a176.svg","height":48,"width":88};